import { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { collection, getDocs, orderBy, query } from 'firebase/firestore';
import { db } from '../firebase';

const VehiclesContext = createContext({
  vehicles: [],
  loading: true,
  error: '',
  refreshVehicles: async () => {},
});

function normalizeVehicle(doc) {
  const rawData = doc.data();
  const imageUrls = Array.isArray(rawData.imageUrls) && rawData.imageUrls.length > 0
    ? rawData.imageUrls
    : rawData.imageUrl
      ? [rawData.imageUrl]
      : [];

  return {
    id: doc.id,
    ...rawData,
    imageUrls,
    imageUrl: imageUrls[0] || '',
  };
}

export function VehiclesProvider({ children }) {
  const [vehicles, setVehicles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const refreshVehicles = async () => {
    try {
      setLoading(true);
      setError('');

      const vehiclesQuery = query(
        collection(db, 'vehicles'),
        orderBy('createdAt', 'desc')
      );

      const snapshot = await getDocs(vehiclesQuery);
      setVehicles(snapshot.docs.map(normalizeVehicle));
    } catch {
      setVehicles([]);
      setError('We could not load the vehicle stock right now. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    refreshVehicles();
  }, []);

  const value = useMemo(() => ({
    vehicles,
    loading,
    error,
    refreshVehicles,
  }), [vehicles, loading, error]);

  return (
    <VehiclesContext.Provider value={value}>
      {children}
    </VehiclesContext.Provider>
  );
}

export function useVehicles() {
  return useContext(VehiclesContext);
}
